tinymce.PluginManager.add('ccimagepicker', function (editor) {
  const openDialog = () => {
    return editor.windowManager.open({
      title: 'Select an image to add to your text',
      body: {
        type: 'panel',
        items: [
          {
            type: 'selectbox',
            label: 'Image',
            name: 'image_type',
            items: [
              { text: 'Study logo', value: 'study-logo' },
              { text: 'Compass Categorieen', value: 'intro-compass-start' },
              {
                text: 'Compass Categorieen - Competenties',
                value: 'intro-compass-progress',
              },
              { text: 'Compass completed', value: 'compass-complete' },
            ],
          },
        ],
      },
      buttons: [
        {
          type: 'submit',
          text: 'OK',
          primary: true,
        },
        {
          type: 'cancel',
          text: 'CANCEL',
        },
      ],
      onSubmit: (dialog) => {
        editor.focus();
        const imgData = dialog.getData().image_type;
        if (imgData) {
          editor.insertContent('[img ' + imgData + ']');
          editor.fire('keyup');
          dialog.close();
        }
      },
    });
  };
  editor.ui.registry.addButton('ccImagePicker', {
    title: 'Add a Career Compass image to your text',
    text: 'Career Compass Image',
    onAction: () => {
      openDialog();
    },
  });
});
